import {
  Box,
  Stack,
  Typography,
  IconButton,
  Popover,
  List,
  ListItemButton,
  ListItemIcon,
  Button,
  Dialog,
  CircularProgress,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useLocation, useNavigate } from 'react-router-dom';
// import CustomAvatar from '../../../component/CustomAvatar';
// import { useQuery } from '@tanstack/react-query';
// import { fetchUserInfo } from '../../../utils/apis/users';
import { reportPost } from '../../../utils/api';
import { PostType } from '../memeverse_types';
import ImageItem from '../imageItem';
import CommentIcon from '../../../svg/MemeverseIcons/CommentIcon';
import HeartIcon from '../../../svg/MemeverseIcons/HeartIcon';
import ShareIcon2 from '../../../svg/ShareIcon2';
import Email from '../../../svg/email';
import { ReactComponent as FacebookIcon } from '../../../svg/Shareicons/facebook.svg';
import { ReactComponent as TwitterIcon } from '../../../svg/Shareicons/twitter.svg';
import { ReactComponent as LinkedinIcon } from '../../../svg/Shareicons/linkedin.svg';
import { ReactComponent as WhatsappIcon } from '../../../svg/Shareicons/whatsapp.svg';
import { ReactComponent as TelegramIcon } from '../../../svg/Shareicons/telegram.svg';
import { ReactComponent as RedditIcon } from '../../../svg/Shareicons/reddit.svg';
// import GenerateIcon from '../../../svg/MemeverseIcons/GenerateIcon';
import ViewsIcon from '../../../svg/MemeverseIcons/ViewsIcon';
import { memo, useEffect, useRef, useState } from 'react';
import { useAuth } from '../../../hooks/useAuth';
// import EditIcon from '../../../svg/MemeverseIcons/EditIcon';
import DeleteIcon from '../../../svg/MemeverseIcons/DeleteIcon';
import FollowIcon from '../../../svg/MemeverseIcons/FollowIcon';
import ReportIcon from '../../../svg/MemeverseIcons/ReportIcon';
import {
  createPostlike,
  deletePost,
  followCreator,
  incrementViewOnPost,
} from '../../../utils/apis/memeverse';
import CreateUpdatePost from '../CreateUpdatePost';
import { timeAgo } from '../../../utils/helper';
import CreateUpdateComment from '../CreateUpdateComment';
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  RedditShareButton,
} from 'react-share';
import { toast } from 'react-toastify';
import { useChannel } from 'ably/react';
import UserProfileHoverDialog from './UserProfileHoverDialog';
import ReplyIcon from '../../../svg/MemeverseIcons/ReplyIcon';
import useAnalyticsEventTracker from '../../../hooks/useAnalyticsEventTracker';
import Markdown from '../../userChat/Markdown';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

interface MemeProps {
  post: PostType;
  isDetailsPage?: boolean;
  shouldLimitImageHeight?: boolean;
  commentLimit?: number;
}

const MemeContent: React.FC<MemeProps> =
  ({ post, isDetailsPage, shouldLimitImageHeight, commentLimit }) => {
  const {
    comments_counts,
    content,
    docId,
    images,
    like_counts,
    user_id,
    watch,
    post_user_details,
    is_liked,
    link
  } = post;
  const [moreMenuOpen, setMoreMenuOpen] = useState<boolean>(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [showEditPost, setShowEditPost] = useState<boolean>(false);
  const [showCreateComment, setShowCreateComment] = useState<boolean>(false);
  const [ likedStatus, setLikedStatus ] = useState<{status: boolean, count: number}>(
      {status: !!is_liked, count: like_counts});
  const [showReportConfirm, setShowReportConfirm] = useState(false)
  const [showReportThanks,  setShowReportThanks]  = useState(false)
  const [imageDialogOpen, setImageDialogOpen] = useState<boolean>(false);
  const [dialogImageIndex, setDialogImageIndex] = useState<number>(0);

  const moreMenuAnchor = useRef(null);
  const isMounted = useRef<boolean>(false);
  const postRef = useRef<any>(null);
  const hasSeenPost = useRef<boolean>(false);

  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { authUser, setLoginModalVisible } = useAuth();
  const eventTracker = useAnalyticsEventTracker();
  const { publish } = useChannel('ask');


  useEffect(() => {
    if (isMounted.current) {
      if (showCreateComment) {
        publish('comment.thinking.new', {
          userId: authUser?.uid,
          parentId: docId,
          level: 0,
          userType: 'user',
          user_details: {
            userName: authUser?.userName,
            profilePicUrl: authUser?.profilePicUrl,
            fullName: authUser?.fullName,
            user_id: authUser?.uid,
          },
        });
      } else {
        publish('comment.thinking.remove', {
          userId: authUser?.uid,
          parentId: docId,
          level: 0,
          userType: 'user',
        });
      }
    } else {
      isMounted.current = true;
    }
  }, [showCreateComment]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    try {
      const observer = new IntersectionObserver((entries) => {
        if (
          entries[0].isIntersecting &&
          isMounted.current &&
          !hasSeenPost.current
        ) {
          hasSeenPost.current = true;
          incrementViewOnPost(authUser?.uid, docId).catch((err) => {});
        }
      });

      observer.observe(postRef.current);

      return () => {
        observer.disconnect();
      };
    } catch (err) {}
  }, [isMounted.current, hasSeenPost.current]); //eslint-disable-line react-hooks/exhaustive-deps

  const handleMoreMenu = () => {
    setMoreMenuOpen(!moreMenuOpen);
  };

  // const handleGenerate = () => {};

  const handleComment = () => {
    if (authUser) {
      setShowCreateComment(!showCreateComment);
    } else {
      setLoginModalVisible({
        isOpen: true,
        formType: 'signin',
        currentStep: 1,
      });
    }
  };

  const handleLike = () => {
    if (authUser) {
      setLikedStatus((prev) => {
        if (prev.status) {
          return {
            status: false,
            count: prev.count - 1,
          }
        } else {
          return {
            status: true,
            count: prev.count + 1,
          }
        }
      })
      createPostlike(authUser.uid, docId)
        .catch((err) => {
          console.log('Like failed: ', err);
        });
    } else {
      setLoginModalVisible({
        isOpen: true,
        formType: 'signin',
        currentStep: 1,
      });
    }
  };

  // const handleShare = () => {};

  // const handleEdit = () => {
  //   setShowEditPost(true);
  //   setMoreMenuOpen(false);
  // };

  const handleDeleteConfirmation = () => {
    setDeleteConfirmation(!deleteConfirmation);
  };

  const handleImageClick = (e: React.MouseEvent, index: number) => {
    e.preventDefault();
    e.stopPropagation();
    setDialogImageIndex(index);
    setImageDialogOpen(true);
  };

  const handleFollow = () => {
    if (authUser) {
      followCreator(authUser?.uid, user_id)
        .then((res) => {
          if (res.ok) {
            return res.json();
          }
        })
        .then((data) => {
          // data has "action": "followed", "docId": "id", "success": "true"
          // just check existence of docId
          if (data.docId) {
            toast.success(
              `Now following ${post_user_details?.fullName || 'creator'}`
            );
          } else {
            toast.warning(
              `Unfollowed ${post_user_details?.fullName || 'creator'}`
            );
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setMoreMenuOpen(false);
        });
    } else {
      setLoginModalVisible({
        isOpen: true,
        formType: 'signin',
        currentStep: 1,
      });
    }
  };

  const handleReport = () => {
    if (!authUser) {
      return setLoginModalVisible({ isOpen: true, formType: 'signin', currentStep: 1 })
    }
    setMoreMenuOpen(false)
    setShowReportConfirm(true)
  }

  const submitReport = async () => {
    try {
      await reportPost(
        authUser.uid,
        docId,
        content[content.length - 1]?.content_body || ''
      );
      setShowReportConfirm(false);
      setShowReportThanks(true);
    } catch (err) {
      console.error(err);
      toast.error('Failed to submit report');
    }
  };


  const handleDelete = async () => {
    setIsDeleting(true);
    deletePost(authUser.uid, docId).then(() => {
      setDeleteConfirmation(false);
      setMoreMenuOpen(false);
      setIsDeleting(false);
      // To-do: force refresh
      navigate('/');
    });
  };

  const [shareOpen, setShareOpen] = useState(false);
  // const [shareAnchorEl, setShareAnchorEl] = useState<null | HTMLElement>(null);
  // const isShareOpen = Boolean(shareAnchorEl);

  const handleShareOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setShareOpen(true);
  };

  const handleShareClose = () => {
    setShareOpen(false);
  };

  return (
    <Stack
      ref={postRef}
      direction='row'
      sx={{
        width: '100%',
        cursor: isDetailsPage ? 'default' : 'pointer',
        gap: { xs: 1.5, md: 2 },
        maxWidth: '100%',
        textDecoration: 'none',
      }}
      onClick={(e) => {
        if (!isDetailsPage && !moreMenuOpen) {
          e.preventDefault();
          e.stopPropagation();
          navigate(`/ask/post/${post.docId}`,
            {
              state:
                {
                  from: location.pathname,
                  scrollY: document.getElementById("ask-scroll-box")?.scrollTop || 0
                }
            }
          );
        }
      }}
      component={isDetailsPage ? 'div' : 'a'}
      href={isDetailsPage ? undefined : `/ask/post/${post.docId}`}
    >
      {/* Left column: Avatar and vertical line */}
      <Stack
        direction='column'
        alignItems='center'
        sx={{
          width: '48px',
          mt: 0.5,
        }}
      >
        {/* <CustomAvatar
          src={post_user_details?.profilePicUrl}
          sx={{ width: 48, height: 48 }}
        /> */}
        <UserProfileHoverDialog
          post_user_details={post_user_details}
          is_requester_following={post?.is_requester_following}
          show_following={!post.article_id}
        />
        {comments_counts > 0 && (
          <Box
            sx={{
              flexGrow: 1,
              borderLeft: '2px solid',
              borderColor: 'grey.300',
              mt: 1,
            }}
          />
        )}
      </Stack>
      {/* Right column: Main content */}
      <Stack
        direction='column'
        sx={{
          flex: 1,
          maxWidth: 'calc(100% - 48px - 12px)',
        }}
      >
        {/* User info row */}
        <Stack
          direction='row'
          spacing={1}
          alignItems='center'
          justifyContent='space-between'
          sx={{
            maxWidth: '100%',
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'row',
              gap: 1,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          >
            <Typography
              variant='h7'
              color='text.primary'
              sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}
            >
              {post_user_details?.fullName}
            </Typography>
            <Typography
              variant='body2'
              color='text.secondary'
              sx={{ whiteSpace: 'nowrap' }}
            >
              @{post_user_details?.userName}
            </Typography>
            <Typography
              variant='body2'
              color='text.secondary'
              sx={{ whiteSpace: 'nowrap' }}
            >
              &#x2022;
            </Typography>
            {/* <Typography variant="body2" color="text.secondary" sx={{whiteSpace: 'nowrap',}}>
              {timeAgo(content[content.length-1]?.row_created)}
            </Typography> */}
            <Typography
              variant='body2'
              color='text.secondary'
              sx={{ whiteSpace: 'nowrap' }}
            >
              {content &&
              content.length > 0 &&
              content[content.length - 1]?.row_created
                ? timeAgo(content[content.length - 1]?.row_created)
                : ''}
            </Typography>
          </Box>
          <Box ref={moreMenuAnchor}>
            <IconButton
              size='small'
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleMoreMenu();
              }}
            >
              <MoreHorizIcon />
            </IconButton>
            <Popover
              open={moreMenuOpen}
              anchorEl={moreMenuAnchor.current}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              onClose={handleMoreMenu}
            >
              <Box
                display='flex'
                flexDirection='column'
                // p={1}
                // gap={1.5}
              >
                {authUser?.documentId === user_id ? (
                  deleteConfirmation ? (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        p: 3,
                        gap: 4,
                        maxWidth: '450px',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 1.5,
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1.5,
                            stroke: (theme) => theme.palette.error.main,
                          }}
                        >
                          <DeleteIcon width={28} stroke='inherit' />
                          <Typography variant='h6'>Delete Post?</Typography>
                        </Box>
                        <Typography variant='body1'>
                          This can't be undone and it will be removed for your
                          profile, the timeline of any accounts that follow you,
                          and from any accounts that have replied to you.
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          width: '100%',
                          gap: 2,
                        }}
                      >
                        <Button
                          variant='outlined'
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            handleDeleteConfirmation();
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant='contained'
                          color='error'
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            handleDelete();
                          }}
                          startIcon={
                            isDeleting ? (
                              <CircularProgress size={20} color='inherit' />
                            ) : (
                              <></>
                            )
                          }
                        >
                          Delete Post
                        </Button>
                      </Box>
                    </Box>
                  ) : (
                    <List>
                      {/* <ListItemButton
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          handleEdit();
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            p: 0,
                            pr: 2,
                            fill: (theme) => theme.palette.primary.main,
                          }}
                        >
                          <EditIcon width={19} fill='inherit' />
                        </ListItemIcon>
                        <Typography variant="body2">
                          {`Edit Post`}
                        </Typography>
                      </ListItemButton> */}

                      <ListItemButton
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          handleDeleteConfirmation();
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            p: 0,
                            pr: 2,
                            stroke: (theme) => theme.palette.error.main,
                          }}
                        >
                          <DeleteIcon width={19} stroke='inherit' />
                        </ListItemIcon>
                        <Typography variant='body2' color='error.main'>
                          {`Delete`}
                        </Typography>
                      </ListItemButton>
                    </List>
                  )
                ) : (
                  <List>
                    <ListItemButton
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        handleFollow();
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          p: 0,
                          pr: 2,
                          fill: (theme) => theme.palette.primary.main,
                          stroke: (theme) => theme.palette.primary.main,
                        }}
                      >
                        <FollowIcon
                          width={19}
                          fill='inherit'
                          stroke='inherit'
                        />
                      </ListItemIcon>
                      <Typography variant='body2'>
                        {`Follow @${post_user_details?.userName}`}
                      </Typography>
                    </ListItemButton>
                    <ListItemButton
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        handleReport();
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          p: 0,
                          pr: 2,
                          fill: (theme) => theme.palette.primary.main,
                        }}
                      >
                        <ReportIcon width={19} fill='inherit' />
                      </ListItemIcon>
                      <Typography variant='body2'>{`Report Post`}</Typography>
                    </ListItemButton>
                  </List>
                )}
              </Box>
            </Popover>
          </Box>
        </Stack>
        {/* Description row */}
        <Typography
          variant='body1'
          color='text.primary'
          mb={{xs: 0, sm: 0.5, md: 1}}
          mt={-0.5}
          component="div"
          sx={[!isDetailsPage ? {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 3,
            whiteSpace: 'normal',
          } : {}]}
        >
          <span className={`markdown`}>
            <Markdown
              components={{
                p: ({ children }) => <span>{children}</span>,
              }}
            >
              {!!content && content[content.length - 1]?.content_body}
            </Markdown>
          </span>
          {
            !!link &&
            <IconButton
              component='a'
              href={link}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                window.open(link, '_blank')
              }}
              size="small"
              sx={{
                padding: 0,
                marginLeft: 1,
                marginBottom: 0.25,
              }}
            >
              <OpenInNewIcon />
            </IconButton>
          }
        </Typography>
        {/* Image row (16:9 ratio) */}
        <Stack
          display={images?.length ? 'flex' : 'none'}
          direction='column'
          spacing={1}
          sx={[
            {
              width: 'auto',
              mb: {xs: 0, sm: 0.5, md: 1},
            },
            shouldLimitImageHeight && {
            maxHeight: `calc(100dvh - 86px ${isMobile ? '- 82px' : '' } - ${Math.min(commentLimit + 1, comments_counts + 1)} * 157px ${comments_counts > commentLimit ? '- 24px' : ''})`,
          }
          ]}
        >
          {!!images?.length && images.map((image, index) => (
            <Box
              key={index}
              onClick={e => handleImageClick(e, index)}
              sx={{
                cursor: 'pointer',
                height: '100%',
                // display: 'inline-block'
              }}
            >
              <ImageItem
                image={image}           // image is a string
                alt={`meme image ${index + 1}`}
              />
            </Box>
          ))}
        </Stack>
        {/* Actions row */}
        <Stack direction="row" justifyContent="flex-start" sx={{gap: {xs: 0, md: 1.5}}}>

          {/* <Stack direction="row" alignItems="center" spacing={0.5}>
            <IconButton
              size='small'
              sx={{
                stroke: (theme) => theme.palette.text.secondary,
                fill: (theme) => theme.palette.text.secondary,
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleGenerate();
              }}
            >
              <GenerateIcon stroke='inherit' fill='inherit' />
            </IconButton>
          </Stack> */}

          <Stack direction='row' alignItems='center' spacing={0.5}>
            <IconButton
              size='small'
              sx={{
                stroke: (theme) => theme.palette.text.secondary,
                borderRadius: (theme) => theme.shape.borderRadiusLg,
                px: {xs: 1, md: 1.5},
                ml: {xs: '-8px !important', md: '-12px !important'},
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleComment();
              }}
            >
              <ReplyIcon stroke='inherit'/>
              <Typography variant='body2' color='text.secondary' sx={{ml: 0.5}}>
                Reply
              </Typography>
            </IconButton>
          </Stack>

          <Stack direction='row' alignItems='center' spacing={0.5}>
            <IconButton
              size='small'
              sx={{
                stroke: (theme) => theme.palette.text.secondary,
                borderRadius: (theme) => theme.shape.borderRadiusLg,
                px: {xs: 1, md: 1.5},
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleComment();
              }}
            >
              <CommentIcon stroke='inherit' />
              <Typography variant='body2' color='text.secondary' sx={{ml: 0.5}}>
                {comments_counts}
              </Typography>
            </IconButton>
          </Stack>

          <Stack direction='row' alignItems='center' spacing={0.5}>
            <IconButton
              size='small'
              sx={{
                stroke: (theme) => theme.palette.text.secondary,
                borderRadius: (theme) => theme.shape.borderRadiusLg,
                px: {xs: 1, md: 1.5},
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleLike();
              }}
            >
              <HeartIcon
                stroke={likedStatus.status ? 'red' : "inherit"}
                fill={likedStatus.status ? 'red' : 'none'}
              />
              <Typography variant='body2' color='text.secondary' sx={{ml: 0.5}}>
                {likedStatus.count}
              </Typography>
            </IconButton>
          </Stack>

          <Stack
            direction='row'
            alignItems='center'
            spacing={0.5}
            sx={{
              stroke: (theme) => theme.palette.text.secondary,
              px: {xs: 1, md: 1.5},
            }}
          >
            <ViewsIcon stroke='inherit' />
            <Typography variant='body2' color='text.secondary'>
              {watch || 0}
            </Typography>
          </Stack>

          <Stack direction='row' alignItems='center' spacing={0.5}>
            <IconButton
              size='small'
              sx={{ stroke: (theme) => theme.palette.text.secondary }}
              onClick={(e: React.MouseEvent<HTMLElement>) => {
                e.preventDefault();
                e.stopPropagation();
                handleShareOpen(e);
              }}
            >
              <ShareIcon2 stroke='inherit' />
            </IconButton>
            <Dialog
              open={shareOpen}
              onClose={(e: React.SyntheticEvent) => {
                e.stopPropagation();
                handleShareClose();
              }}
              fullWidth
              maxWidth='xs'
              PaperProps={{
                sx: {
                  borderRadius: 4,
                  padding: 2,
                  backdropFilter: 'blur(8px)',
                  backgroundColor: 'rgba(255, 255, 255, 0.85)',
                },
                onClick: (e) => e.stopPropagation(),
              }}
            >
              <Box sx={{ textAlign: 'center', p: 2 }}>
                <Typography variant='h6' mb={2}>
                  Share to social
                </Typography>
                <Stack
                  direction='row'
                  spacing={1}
                  justifyContent='center'
                  flexWrap='wrap'
                >
                  <Stack direction='column' alignItems='center' spacing={0.5}>
                    <FacebookShareButton
                      url={`${window.location.origin}/ask/post/${docId}`}
                      onClick={e => {
                        e.stopPropagation()
                        eventTracker('ask-share', {
                          type: 'comment',
                          location: 'facebook',
                        })
                      }}
                    >
                      <IconButton
                        sx={{
                          cursor: 'pointer',
                          '&:hover': {
                            transform: 'scale(1.1)',
                            borderColor: 'rgba(0,0,0,0.3)',
                          },
                        }}
                      >
                        <FacebookIcon width={40} height={40} />
                      </IconButton>
                    </FacebookShareButton>
                    <Typography variant='caption' color='text.secondary'>
                      Facebook
                    </Typography>
                  </Stack>

                  <Stack direction='column' alignItems='center' spacing={0.5}>
                    <TwitterShareButton
                      url={`${window.location.origin}/ask/post/${docId}`}
                      title={`Check this out in SoopraAI!\n${
                        content[0]?.content_body || ''
                      }\n`}
                      onClick={e => {
                        e.stopPropagation()
                        eventTracker('ask-share', {
                          type: 'comment',
                          location: 'twitter',
                        })
                      }}
                    >
                      <IconButton>
                        <TwitterIcon width={40} height={40} />
                      </IconButton>
                    </TwitterShareButton>
                    <Typography variant='caption' color='text.secondary'>
                      X
                    </Typography>
                  </Stack>

                  <Stack direction='column' alignItems='center' spacing={0.5}>
                    <LinkedinShareButton
                      url={`${window.location.origin}/ask/post/${docId}`}
                      onClick={e => {
                        e.stopPropagation()
                        eventTracker('ask-share', {
                          type: 'comment',
                          location: 'linkedin',
                        })
                      }}
                    >
                      <IconButton
                        sx={{
                          cursor: 'pointer',
                          '&:hover': {
                            transform: 'scale(1.1)',
                            borderColor: 'rgba(0,0,0,0.3)',
                          },
                        }}
                      >
                        <LinkedinIcon width={40} height={40} />
                      </IconButton>
                    </LinkedinShareButton>
                    <Typography variant='caption' color='text.secondary'>
                      Linkedin
                    </Typography>
                  </Stack>

                  <Stack direction='column' alignItems='center' spacing={0.5}>
                    <WhatsappShareButton
                      url={`${window.location.origin}/ask/post/${docId}`}
                      title={content[0]?.content_body}
                      onClick={e => {
                        e.stopPropagation()
                        eventTracker('ask-share', {
                          type: 'comment',
                          location: 'whatsapp',
                        })
                      }}
                    >
                      <IconButton
                        sx={{
                          cursor: 'pointer',
                          '&:hover': {
                            transform: 'scale(1.1)',
                            borderColor: 'rgba(0,0,0,0.3)',
                          },
                        }}
                      >
                        <WhatsappIcon width={40} height={40} />
                      </IconButton>
                    </WhatsappShareButton>
                    <Typography variant='caption' color='text.secondary'>
                      Whatsapp
                    </Typography>
                  </Stack>

                  <Stack direction='column' alignItems='center' spacing={0.5}>
                    <TelegramShareButton
                      url={`${window.location.origin}/ask/post/${docId}`}
                      title={content[0]?.content_body}
                      onClick={e => {
                        e.stopPropagation()
                        eventTracker('ask-share', {
                          type: 'comment',
                          location: 'telegram',
                        })
                      }}
                    >
                      <IconButton
                        sx={{
                          cursor: 'pointer',
                          '&:hover': {
                            transform: 'scale(1.1)',
                            borderColor: 'rgba(0,0,0,0.3)',
                          },
                        }}
                      >
                        <TelegramIcon width={40} height={40} />
                      </IconButton>
                    </TelegramShareButton>
                    <Typography variant='caption' color='text.secondary'>
                      Telegram
                    </Typography>
                  </Stack>

                  <Stack direction='column' alignItems='center' spacing={0.5}>
                    <RedditShareButton
                      url={`${window.location.origin}/ask/post/${docId}`}
                      title={content[0]?.content_body}
                      onClick={e => {
                        e.stopPropagation()
                        eventTracker('ask-share', {
                          type: 'comment',
                          location: 'reddit',
                        })
                      }}
                    >
                      <IconButton
                        sx={{
                          cursor: 'pointer',
                          '&:hover': {
                            transform: 'scale(1.1)',
                            borderColor: 'rgba(0,0,0,0.3)',
                          },
                        }}
                      >
                        <RedditIcon width={40} height={40} />
                      </IconButton>
                    </RedditShareButton>
                    <Typography variant='caption' color='text.secondary'>
                      Reddit
                    </Typography>
                  </Stack>
                </Stack>

                <Box mt={3}>
                  <Typography
                    variant='body2'
                    color='text.secondary'
                    mb={1}
                    sx={{ textAlign: 'left' }}
                  >
                    Link
                  </Typography>
                  <Stack direction='row' spacing={1} alignItems='center'>
                    <Box
                      onClick={(e) => e.stopPropagation()}
                      sx={{
                        bgcolor: '#f5f5f5',
                        px: 2,
                        py: 1,
                        borderRadius: 2,
                        flexGrow: 1,
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {`${window.location.origin}/ask/post/${docId}`}
                    </Box>
                    <Button
                      variant='contained'
                      size='small'
                      onClick={(e) => {
                        e.stopPropagation();
                        navigator.clipboard.writeText(
                          `${window.location.origin}/ask/post/${docId}`
                        );
                        eventTracker('ask-share', {
                          type: 'comment',
                          location: 'link',
                        })
                        handleShareClose();
                      }}
                    >
                      Copy
                    </Button>
                  </Stack>
                </Box>
              </Box>
            </Dialog>

            <Dialog
              open={showReportConfirm}
              onClose={() => setShowReportConfirm(false)}
              fullWidth
              maxWidth="xs"
            >
              <Box sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="h6" gutterBottom>
                  Report this post?
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Are you sure you want to report this post for review?
                </Typography>
                <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
                  <Button onClick={() => setShowReportConfirm(false)}>
                    Cancel
                  </Button>
                  <Button variant="contained" color="error" onClick={submitReport}>
                    Yes, report
                  </Button>
                </Stack>
              </Box>
            </Dialog>

            <Dialog
              open={showReportThanks}
              onClose={() => setShowReportThanks(false)}
              fullWidth
              maxWidth="xs"
            >
              <Box sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="h6" gutterBottom>
                Thanks for helping make Soopra Ask a better experience.
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  A report has been emailed to Soopra for review for misconduct.
                </Typography>
                <Box sx={{ my: 2, display: 'flex', justifyContent: 'center' }}>
                  <Email width={32} height={32} />
                </Box>
                <Button variant="contained" onClick={() => setShowReportThanks(false)}>
                  Close
                </Button>
              </Box>
            </Dialog>

            {
              !!images?.length &&
              <Dialog
                open={imageDialogOpen}
                onClose={() => setImageDialogOpen(false)}
                maxWidth="lg"
                PaperProps={{ sx: { bgcolor: 'transparent', boxShadow: 'none' } }}
                BackdropProps={{ sx: { backgroundColor: 'rgba(0,0,0,0.8)' } }}
                onClick={e => e.stopPropagation()}
              >
                <IconButton
                  onClick={() => setImageDialogOpen(false)}
                  sx={{
                    position: 'fixed',
                    top: (theme) => theme.spacing(2),
                    right: (theme) => theme.spacing(2),
                    color: 'white',
                    zIndex: theme => theme.zIndex.modal + 1,
                  }}
                  size="large"
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
                <Box
                  component="img"
                  src={images[dialogImageIndex]}   // <-- just the string URL
                  alt={`enlarged image ${dialogImageIndex + 1}`}
                  sx={{
                    width: '100%',
                    height: 'auto',
                    maxHeight: '90vh',
                    borderRadius: 2,
                    boxShadow: 3,
                  }}
                />
              </Dialog>
            }
            {/* <Typography variant="body2" color="text.secondary">{share_counts}</Typography> */}
          </Stack>
        </Stack>
      </Stack>

      {
        showEditPost &&
        <CreateUpdatePost
          createUpdatePostVisible={showEditPost}
          setCreateUpdatePostVisible={setShowEditPost}
          existingPost={post}
        />
      }

      <Dialog
        open={showCreateComment}
        onClose={() => setShowCreateComment(false)}
        fullWidth
        maxWidth='md'
        slotProps={{
          backdrop: {
            sx: {
              display: { xs: 'none', md: 'block' },
            },
          },
        }}
        PaperProps={{
          sx: {
            m: 0,
            [theme.breakpoints.down('md')]: {
              width: '100%',
              maxWidth: '100%',
              height: 'calc(100% - 107px)',
              maxHeight: 'none',
              boxShadow: 'none',
              mt: '50px',
            },
          },
        }}
        sx={{
          [theme.breakpoints.down('md')]: {
            '& .MuiDialog-container': {
              alignItems: 'flex-start',
            },
          },
        }}
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <CreateUpdateComment
          setCreateUpdateCommentVisible={setShowCreateComment}
          parentPostOrComment={post}
        />
      </Dialog>
    </Stack>
  );
};

export default memo(MemeContent);
